/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, imageTypes, overlay } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : IMAGE PANE : IMAGE : STYLES --------------- ++++++++++ */
export default theme => ({
	image: {
		background: theme.color.supporting.light.swatch,
		width: '100%', //pxToEm(138),
		borderRadius: 'inherit',
		'& .imagevisual': {
			// background image comes from component dynamically
			extend: [imageTypes.photo, overlay],
			backgroundSize: 'cover',
			cursor: 'pointer',
			width: '100%',
			height: pxToEm(138),
			borderRadius: 'inherit',
			position: 'relative',
			zIndex: '1'
		}
	}
});
